(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceTypeController', InsuranceTypeController);

    InsuranceTypeController.$inject = ['$scope', '$state', 'InsuranceType', 'InsuranceTypeSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function InsuranceTypeController ($scope, $state, InsuranceType, InsuranceTypeSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.insuranceTypes = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  InsuranceType.query(function(result) {
                  vm.insuranceTypes = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.insuranceTypes, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            InsuranceType.query(function(result) {
                vm.insuranceTypes = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();
